import React, { useMemo } from 'react'
import { Popover, Row, Col } from 'antd'
import { renderTranslation, stopPropagation } from '../../../Helpers/GenericHelpers'
import { TranslationKeys } from '../../../Constants/TranslationKeys'
import { useAppSelector } from '../../../hooks'

function BarcodeRecapPopover(props) {
  const language = useAppSelector(state => state.present.language.value)

  const sizesAndBarcode = useMemo(() => {
    return props.publicBarcode.split('|')
  }, [props.publicBarcode])
  const sizeBarcodeTable = useMemo(() => {
    return (
      <div>
        <table
          className='barcode-recap-table'
          onClick={e => {
            e.stopPropagation()
          }}
        >
          <thead>
            <tr key={'barcode-recap-head-row'}>
              <th className='head-size'>{renderTranslation(language, TranslationKeys.tableBarcodeRecapPopoverSize)}</th>
              <th className='head-barcode'>
                {renderTranslation(language, TranslationKeys.tableBarcodeRecapPopoverBarcode)}
              </th>
            </tr>
          </thead>
          <tbody>
            {sizesAndBarcode.map((element, index) => {
              const sizeAndValue = element.split(':')
              return sizeAndValue[0] && sizeAndValue[1] ? (
                <tr key={index}>
                  <td className='body-size'>{sizeAndValue[1]}</td>
                  <td className={'body-barcode' + (sizeAndValue[0] !== 'NULL' ? '' : ' empty')}>
                    {sizeAndValue[0] !== 'NULL' ? sizeAndValue[0] : ''}
                  </td>
                </tr>
              ) : null
            })}
          </tbody>
        </table>
      </div>
    )
  }, [language, sizesAndBarcode])

  return (
    <Popover id='barcode-recap-popover' trigger={'hover'} placement={'left'} content={sizeBarcodeTable}>
      <Row onClick={stopPropagation}>
        <Col flex='auto'>{props.children}</Col>
      </Row>
    </Popover>
  )
}

export default BarcodeRecapPopover
